
import { Component, Inject, ChangeDetectorRef} from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatBottomSheet } from '@angular/material';
import { WhitelabelConfig } from '../../../models/whitelabel-config.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { Whitelabel } from '../../../models/whitelabel.model';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { EditDefaultSheetComponent } from './edit-default/edit-default-sheet';
import { WhitelabelFeature } from '../../../models/whitelabel-feature.model';

@Component({
    selector: 'whitelabel-configs',
    template: require('./whitelabel-configs.component.html'),
    styles: [require('./whitelabel-configs.component.css')]
})
export class WhitelabelConfigsComponent {
    whitelabelConfigs: Array<WhitelabelConfig>;
    whitelabelFeatures: Array<WhitelabelFeature>;
    whitelabelFeatureSpecific: WhitelabelFeature 
    whitelabelId: number;
    whitelabel: any = {};
    selectedWhitelabelConfig: any = {};
    selectedWhitelabelFeature: any = {};

    /**
     * Stands in for "+ Add new Feature" at the top of the feature list. It is not a
     * feature, so picking it opens the editor and puts the previous choice back.
     */
    readonly addNewFeature: any = { addNew: true };
    private lastSelectedFeature: any = '';

   public  Object = Object;
    constructor(private changeRef: ChangeDetectorRef, private bottomSheet: MatBottomSheet,private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<WhitelabelConfigsComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.whitelabel = data.whitelabel;
        this.whitelabelId = data.whitelabel.whitelabelId;
        this.whitelabelFeatureSpecific = data.whitelabelFeature
        this.whitelabelFeatures = data.whitelabelFeatures
        this.selectedWhitelabelFeature = this.whitelabelFeatureSpecific ? this.whitelabelFeatures.find(w => w.whitelabelFeatureId === this.whitelabelFeatureSpecific.whitelabelFeatureId) : '';
        this.getWhitelabelConfigs();
        //this.getWhitelabelFeatures();
    }

    getWhitelabelConfigs() {
        this.apiService.getWhitelabelConfigs(this.whitelabelId).subscribe(r => {
            this.whitelabelConfigs = r;
            //console.log(r)
            this.whitelabelFeatureSpecific ? this.selectionChange() : ''
            this.changeRef.detectChanges();
        })
    }

    isOverwrited(f) {
        return _.some(this.whitelabelConfigs, c => {
            return c.whitelabelFeatureId ==  f.whitelabelFeatureId
        })
    }

    getWhitelabelFeatures() {
        this.apiService.getWhitelabelFeatures().subscribe(r => {
            this.whitelabelFeatures = r;
            _.each(this.whitelabelFeatures, f => {
                f.defaultSettingsObj = JSON.parse(f.defaultSettings);
            })
            
            this.selectedWhitelabelFeature = this.whitelabelFeatureSpecific ? this.whitelabelFeatures.find(w => w.whitelabelFeatureId === this.whitelabelFeatureSpecific.whitelabelFeatureId) : '';
            this.selectionChange()
            this.changeRef.detectChanges();
        })
    }

    /**
     * Edits the settings every site starts from. Saving carries each changed field to the
     * sites that were still following the old default -- a site with its own value for that
     * field keeps it, which is the whole point of the Overwrite column beside this.
     */
    editDefault(whitelabelFeature) {
        var ref = this.bottomSheet.open(EditDefaultSheetComponent, {
            data: {
                whitelabelFeature: whitelabelFeature
            },
        });

        ref.afterDismissed().subscribe(saved => {
            // The server rewrites defaultSettings, so re-read rather than patching locally.
            if (saved) { this.reloadFeatures(whitelabelFeature.whitelabelFeatureId); }
        })
    }

    addNew() {
       var ref = this.bottomSheet.open(EditDefaultSheetComponent, {
            data: {
                whitelabelFeature: {},
                whitelabelId: this.whitelabelId
            },
        });

        ref.afterDismissed().subscribe((created: any) => {
            if (!created) { return; }

            // Selected once it is back from the server, so the next step -- giving this site
            // an override for it -- is the one already on screen.
            this.reloadFeatures(created.whitelabelFeatureId);
        })
    }

    /**
     * Re-reads the features after their defaults changed, keeping one selected.
     *
     * The array is refilled rather than replaced: the whitelabels list that opened this
     * dialog passed its own array in and would otherwise go on showing the old settings.
     */
    private reloadFeatures(selectFeatureId?: number) {
        this.apiService.getWhitelabelFeatures().subscribe(r => {
            var features = r || [];

            _.each(features, (f: any) => {
                try {
                    f.defaultSettingsObj = JSON.parse(f.defaultSettings);
                } catch (e) {
                    f.defaultSettingsObj = {};
                }
            })

            this.whitelabelFeatures.length = 0;
            _.each(features, (f: any) => this.whitelabelFeatures.push(f));

            var wanted = selectFeatureId || (this.selectedWhitelabelFeature || {}).whitelabelFeatureId;
            var selected = _.find(this.whitelabelFeatures, (f: any) => f.whitelabelFeatureId === wanted);

            if (selected) {
                this.selectedWhitelabelFeature = selected;
                this.selectionChange();
            }

            this.changeRef.detectChanges();
        })
    }


    ok() {

        var array = [];

        _.each(this.whitelabelConfigs, config => {
            array.push(this.apiService.updateWhitelabelConfig(config));
        })

        Observable.forkJoin(array).subscribe(r => {
            this.dialogRef.close(r);
            this.alertService.showMessage("", "Save whitelabel configs successfully!", MessageSeverity.success);
        });

    }

    save() {
        var config = _.cloneDeep(this.selectedWhitelabelConfig);
        config.featureSettings = JSON.stringify(config.featureSettingsObj);
        delete config.featureSettingsObj;

        if (config.whitelabelId && config.whitelabelFeatureId) {
            this.apiService.updateWhitelabelConfig(config).subscribe(r => {
                this.dialogRef.close(r);
                this.alertService.showMessage("", "Save whitelabel configs successfully!", MessageSeverity.success);
            })
        } else {
            config.whitelabelId = this.whitelabelId;
            config.whitelabelFeatureId = this.selectedWhitelabelFeature.whitelabelFeatureId;
            this.apiService.createWhitelabelConfig(config).subscribe(r => {
                this.dialogRef.close(r);
                this.alertService.showMessage("", "Create new whitelabel configs successfully!", MessageSeverity.success);
            })
        }
    }

    selectionChange() {
        if (this.selectedWhitelabelFeature === this.addNewFeature) {
            this.selectedWhitelabelFeature = this.lastSelectedFeature || '';
            this.addNew();
            return;
        }

        this.lastSelectedFeature = this.selectedWhitelabelFeature;

        //console.log(this.selectedWhitelabelFeature)
        this.selectedWhitelabelConfig = _.find(this.whitelabelConfigs, { whitelabelFeatureId: this.selectedWhitelabelFeature.whitelabelFeatureId });
        if (!this.selectedWhitelabelConfig) return;
        this.selectedWhitelabelConfig.featureSettingsObj = JSON.parse(this.selectedWhitelabelConfig.featureSettings)
        this.changeRef.detectChanges();
        //console.log(this.selectedWhitelabelFeature)
        //console.log(this.selectedWhitelabelConfig)
    }

    addConfig() {
        this.selectedWhitelabelConfig = { };
        this.selectedWhitelabelConfig.featureSettingsObj = _.cloneDeep(this.selectedWhitelabelFeature.defaultSettingsObj);
        this.changeRef.detectChanges();
    }

    removeConfig(config) {

        this.apiService.deleteWhitelabelConfig(config.whitelabelId, config.whitelabelFeatureId).subscribe(r => {
            this.alertService.showMessage("", "removed whitelabel config successfully!", MessageSeverity.success);
            this.selectedWhitelabelConfig = null;
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/whitelabels/whitelabel-configs/whitelabel-configs.component.ts